import { Stack, Typography, TextField, MenuItem } from "@mui/material";
import { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import StyledButton from "../../components/StyledButton";
import { OnChangeTextField } from "../../components/TextField";
import { getUserRowType } from "../../schema/console/user";
import { GroupBase } from "../../schema/generated/Group";
import { VoidAction } from "../../util/func";
import { PageContext } from "./Pages";

export default function GroupPageLayout({ pageContext,　groupData, update }: { pageContext: PageContext, groupData: GroupBase[], update: VoidAction } ) {
  return (
    <Routes>
      <Route index element={<>グループIDが見つかりません。</>} />
      <Route path=":id/" element={<GroupPage pageContext={pageContext} groups={groupData} update={update} />}></Route>
      <Route path="new/" element={<GroupCreatePage pageContext={pageContext} update={update} />} />
    </Routes>
  );
}

function GroupCreatePage({ pageContext, update }: { pageContext: PageContext, update: VoidAction }) {
  const navigate = useNavigate();

  const [name, setName] = useState<string>();
  const error = Boolean(name?.trim());

  return (
    <Stack width="100%" alignItems="center" pt="70px" gap={4} pb={8}>
      <Stack maxWidth={1200} width="80%" gap="26px">
        <Stack direction="row" alignItems="">
          <Typography fontSize={24} fontWeight="bold">グループ情報</Typography>
        </Stack>
        <OnChangeTextField label="グループ名" value={name ?? ""} onChange={setName} error={!name ? "必須" : undefined} />
        <StyledButton buttonStyle="primary" disabled={!error} onClick={() => {
          if (name?.trim()) {
            pageContext.api.group_data.put({ name }).then(() => { 
              update();
              navigate(-1)
            })
          }
        }}>
          <Typography>作成</Typography>
        </StyledButton>
      </Stack>
    </Stack>
  );
}

function GroupPage({ pageContext, groups, update }: { pageContext: PageContext, groups: GroupBase[], update: VoidAction }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const group = groups?.find(user => user.id === id);
  const [name, setName] = useState<string | undefined>(group?.name);


  const error = Boolean(name?.trim());

  if (!group) {
    return <>該当するグループがありません。</>;
  }

  return (
    <Stack width="100%" alignItems="center" pt="70px" gap={4} pb={8}>
      <Stack maxWidth={1200} width="80%" gap="26px">
        <Stack direction="row" alignItems="">
          <Typography fontSize={24} fontWeight="bold">グループ情報</Typography>
        </Stack>
        <OnChangeTextField label="グループ名" value={name ?? ""} onChange={setName} error={!name ? "必須" : undefined} />
        <StyledButton buttonStyle="primary" disabled={!error} onClick={() => {
          if (name?.trim()) {
            pageContext.api.group_data.patch({ id: group.id, name }).then(() => { 
              update();
              navigate(-1)
            })
          }
        }}>
          <Typography>更新</Typography>
        </StyledButton>
      </Stack>
    </Stack>
  );
}
